/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomComponentFilter extends models.AppSecopsFilter {
    getFixupPrototypeFunction() { return AppSecopsSbomComponentFilter.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomComponentFilter>): AppSecopsSbomComponentFilter {
        let obj = Object.assign(new AppSecopsSbomComponentFilter(), model);
        AppSecopsSbomComponentFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomComponentFilter>): AppSecopsSbomComponentFilter {
        if (!model) return null;
        return AppSecopsSbomComponentFilter.newInstance(<AppSecopsSbomComponentFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomComponentFilter) {
        if (!obj) return;

        models.AppSecopsSbomComponentFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomComponentFilter): boolean {
        if (models.AppSecopsFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomComponentFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * If set true, fetch only components associated with vulnerabilities
     */
    vulnerable_components_only: boolean;

}
